export default __webpack_public_path__ + "static/media/desc-img.705a21c6.png";